// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-page-mdx-js": () => import("./../../../src/templates/page-mdx.js" /* webpackChunkName: "component---src-templates-page-mdx-js" */)
}

